// 규칙 기반 간단 모드(spec/simple-mode.md). AI 없이 "무엇을 고치면 이 사람에게 잘 통하는지"를 보여 준다.
// 기기에서 돈다(서버 없음). 엔진이 꺼졌거나 바쁠 때, 오프라인, 8초 초과, 사용자가 AI를 끌 때 쓴다.
// 이번 증분은 검사기(detectors) 서브셋 → 체크리스트. 자동 고치기/틀 재작성은 다음 증분.

export type Situation = 'status_late' | 'ask_help' | 'say_no' | 'nudge' | 'apology' | 'thanks'

interface Ctx { channel: 'chat' | 'mail'; situation: Situation; locale: 'ko' | 'en' }

const firstSentence = (t: string) => t.split(/[.!?\n。]/)[0] || t

const DET: { id: string; test: (draft: string, c: Ctx) => boolean }[] = [
  {
    id: 'conclusion_late',
    test: (d, c) => {
      const fs = firstSentence(d)
      const re = c.locale === 'ko' ? /(드리겠|드릴게|부탁드립|가능할까|하겠습니다|보내드리|공유드리|까지)/ : /(I'?ll|I will|could you|by )/i
      return re.test(d) && !re.test(fs)
    },
  },
  {
    id: 'over_apology',
    test: (d, c) => ((d.match(c.locale === 'ko' ? /죄송|송구|미안/g : /sorry|apologi/gi) || []).length >= 2),
  },
  {
    id: 'hedge',
    test: (d, c) => (c.locale === 'ko' ? /(혹시|괜찮으시면|아마|것\s?같은데|것같)/ : /(\bjust\b|maybe|I was wondering|sort of)/i).test(d),
  },
  {
    id: 'no_deadline',
    test: (d, c) => {
      if (!['status_late', 'ask_help', 'nudge'].includes(c.situation)) return false
      const re = c.locale === 'ko' ? /(\d+\s?월|\d+\s?일|오전|오후|\d+\s?시|내일|모레|월요일|화요일|수요일|목요일|금요일|까지)/ : /(by |mon|tue|wed|thu|fri|\d+\s?(am|pm)|\d+:\d+|tomorrow|today)/i
      return !re.test(d)
    },
  },
  {
    id: 'too_long',
    test: (d, c) => c.channel === 'chat' && (d.length > (c.locale === 'ko' ? 120 : 200) || (d.split(/[.!?\n。]/).filter(s => s.trim()).length > 3)),
  },
  {
    id: 'emoji_mismatch',
    test: (d) => /\p{Extended_Pictographic}/u.test(d) || /ㅠㅠ|ㅜㅜ|ㅋㅋ/.test(d),
  },
]

/** 위반한 검사기 id 목록(최대 4). Compose가 simple.d.<id>로 문구를 보여 준다. */
export function simpleChecklist(draft: string, ctx: Ctx): string[] {
  const text = draft.trim()
  if (!text) return []
  return DET.filter(dt => dt.test(text, ctx)).map(dt => dt.id).slice(0, 4)
}
